<div class="single-license layout-spacing" data-testid="single-license">
    <div class="single-license__upper" data-testid="single-license-upper">
        <div
            class="single-license__upper-left license-info"
            data-testid="single-license-upper-left">
            @for (item of licenseData(); track $index) {
                @if (item.label !== 'Host Name') {
                    <div class="license-info__item" data-testid="license-info-item">
                        <span class="license-info__label">{{ item.label }}:</span>
                        <span class="license-info__value-group">
                            <span class="license-info__value">{{ item.value }}</span>
                            @if (item.label === 'Business Hours' && item.value !== '—') {
                                <svg
                                    class="license-info__info-icon"
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    aria-hidden="true">
                                    <use [attr.href]="spritePath + '#' + icons.infoCircle"></use>
                                </svg>
                            }
                            @if (item.label === 'License Key' && item.value) {
                                <button
                                    type="button"
                                    class="license-info__copy"
                                    (click)="onCopyText(item.value); $event.stopPropagation()"
                                    title="Copy license key"
                                    aria-label="Copy license key">
                                    <svg width="12" height="12">
                                        <use [attr.href]="spritePath + '#' + icons.copy"></use>
                                    </svg>
                                </button>
                            }
                        </span>
                    </div>
                }
            }
        </div>
        <div class="single-license__upper-right" data-testid="single-license-upper-right">
            <div class="btn-right" data-testid="btn-right">
                <ntv-button
                    [variant]="'danger'"
                    [size]="'xl'"
                    (buttonClick)="openDeleteLicenseModal()">
                    <div class="btn-action main-btn" data-testid="btn-action">
                        <span>Delete License</span>
                        <svg width="14" height="14">
                            <use [attr.href]="spritePath + '#' + icons.delete"></use>
                        </svg>
                    </div>
                </ntv-button>

                <ntv-button
                    [variant]="'accent'"
                    [size]="'xl'"
                    (buttonClick)="actions.toggle($event)">
                    <div class="btn-action main-btn" data-testid="btn-action">
                        <span>Take Actions</span>
                        <svg
                            [attr.width]="actions.isVisible() ? 14 : 7"
                            [attr.height]="actions.isVisible() ? 14 : 11">
                            <use
                                [attr.href]="
                                    spritePath +
                                    '#' +
                                    (actions.isVisible() ? 'chevron-down' : 'chevron-right')
                                "></use>
                        </svg>
                    </div>
                </ntv-button>
            </div>
            <ntv-popover #actions placement="bottom-end">
                <div class="popover" data-testid="popover">
                    @for (item of actionItems; track item.label) {
                        <div
                            class="popover__item"
                            (click)="onActionClick(item.label); actions.hide()"
                            data-testid="popover-item">
                            <svg width="16" height="16" [style.color]="'#8DCB2C'">
                                <use [attr.href]="spritePath + '#' + item.icon"></use>
                            </svg>
                            <span>{{ item.label }}</span>
                        </div>
                    }
                </div>
            </ntv-popover>
        </div>
    </div>
    <div class="single-license__tabs">
        <ntv-tabs
            [tabs]="tabs"
            [activeIndex]="activeTab()"
            (tabChange)="onTabChange($event)"></ntv-tabs>

        <div class="tab-content-container">
            <!-- Details and Concept Tab Content -->
            @if (activeTab() === 0) {
                <div class="tab-content">
                    <app-details-concept></app-details-concept>
                </div>
            }
        </div>
    </div>
</div>

<!-- Delete License Confirmation Modal -->
@if (showDeleteLicenseModal()) {
    <app-confirmation-modal
        [isVisible]="showDeleteLicenseModal()"
        size="small"
        type="delete-confirm"
        [title]="'Delete License'"
        [message]="'Are you sure you want to delete this license? Please type the license below to confirm.'"
        [disclaimer]="'Note: Playlists and content associated with this license will remain intact and will not be affected.'"
        [requiredText]="licenseDeleteKey()"
        confirmInputPlaceholder="Type the license to confirm"
        confirmText="Delete"
        cancelText="Cancel"
        [isLoading]="isDeleting()"
        (confirm)="onConfirmDeleteLicense()"
        (cancel)="closeDeleteLicenseModal()"
        (modalClose)="closeDeleteLicenseModal()" />
}

<!-- Delete License Success Modal -->
@if (showDeleteSuccessModal()) {
    <app-confirmation-modal
        [isVisible]="showDeleteSuccessModal()"
        size="small"
        type="success"
        [loopAnimation]="false"
        [title]="'License Deleted'"
        [message]="'The license has been successfully deleted.'"
        [confirmText]="'Close'"
        (confirm)="onDeleteSuccessClose()"
        (modalClose)="onDeleteSuccessClose()" />
}

<!-- License Action Confirmation Modal (Reboot Devices / Push Updates) -->
@if (pendingAction() !== null) {
    <app-confirmation-modal
        [isVisible]="pendingAction() !== null"
        size="small"
        type="warning"
        [showCancelButton]="true"
        [title]="actionModalTitle()"
        [message]="actionModalMessage()"
        [confirmText]="actionModalConfirmText()"
        cancelText="Cancel"
        [isLoading]="isActionRunning()"
        (confirm)="onConfirmAction()"
        (cancel)="closeActionModal()"
        (modalClose)="closeActionModal()" />
}

<!-- License Action Success Modal (Reboot Devices / Push Updates) -->
@if (completedAction() !== null) {
    <app-confirmation-modal
        [isVisible]="completedAction() !== null"
        size="small"
        type="success"
        [title]="actionSuccessTitle()"
        [message]="actionSuccessMessage()"
        confirmText="Close"
        [loopAnimation]="false"
        (confirm)="closeActionSuccessModal()"
        (modalClose)="closeActionSuccessModal()" />
}
